import type { ComponentLoaderType } from '@grafikr/components';
import state from 'utils/state';

const Loader: ComponentLoaderType = ({ node }, load) => {
  const [key, value] = node.dataset.state.split(':');

  if (state.get(key) === value) {
    load();
  }

  return () => {};
};

export default Loader;
